import { NuvemEnvioBillingType } from '@tiendanube/common/src/enums';
import { NUVEMENVIO_LABEL_PRINTING } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';
import { useGetNuvemEnvioConfigs } from 'domains/Shipping/DeliveryMethods/hooks';
import { nuvemEnvioLabelsAppLinkPrefixes } from '../../pages/constants';

interface UseHasNuvemEnvioPrintingEnabledResult {
  hasNuvemEnvioPrintingEnabled: (link: string) => boolean;
}

function useHasNuvemEnvioPrintingEnabled(): UseHasNuvemEnvioPrintingEnabledResult {
  const tags = useGetTags();
  const { nuvemEnvioConfigs } = useGetNuvemEnvioConfigs();

  const hasNuvemEnvioPrintingEnabled = (link: string) => {
    const isNuvemEnvioLink = nuvemEnvioLabelsAppLinkPrefixes.some((substring) =>
      link.includes(substring),
    );
    const enabledByTag = tags.includes(NUVEMENVIO_LABEL_PRINTING);

    return (
      isNuvemEnvioLink &&
      enabledByTag &&
      nuvemEnvioConfigs.billingType === NuvemEnvioBillingType.POST_PAID
    );
  };

  return {
    hasNuvemEnvioPrintingEnabled,
  };
}

export default useHasNuvemEnvioPrintingEnabled;
